import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnselectedCheckbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	stroke: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.66675 20.5609H21.3334V21.3333H2.66675V20.5609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.66675 2.66663H21.3334V3.43899H2.66675V2.66663Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.66675 21.3324V2.66663L3.43468 2.66663V21.3324H2.66675Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.3334 2.66663L21.3334 21.3324H20.5655V2.66663H21.3334Z",
			fill: "currentColor"
		})
	]
});
export default SvgUnselectedCheckbox;
